import Vue from 'vue';
import moment from 'moment';
import { DATE_FORMAT } from '@/constants';

export const handlerResponse = async (response) => {
  if (!response.ok) {
    throw new Error('Error');
  }
  if (response.data) {
    return await response.json();
  }
  return await response.text();
};

export const isObject = (data) => {
  return (!!data) && (data.constructor === Object);
};

export const setToken = (token) => {
  Vue.http.headers.common['Authorization'] = 'token ' + token;
};

export const setNotifyData = (title, message, type, group = 'main') => {
  return {
    group,
    title,
    type,
    text: message
  };
};

export const saveFilters = (storageKey, saveObject) => {
  localStorage.setItem(storageKey, JSON.stringify(saveObject));
};

export const removeFiltersFromStorage = (storageKey) => {
  localStorage.removeItem(storageKey);
};

export const setFilters = (storageKey) => {
  return JSON.parse(localStorage.getItem(storageKey));
};

export const checkSavedFilterData = (storageKey) => {
  return localStorage[storageKey];
};

export const cleanFilters = (searchData, storageKey) => {
  for (const key in searchData) {
    if (searchData.hasOwnProperty(key)) {
      if (Array.isArray(searchData[key])) {
        searchData[key] = [];
      } else if (typeof searchData[key] === 'boolean') {
        searchData[key] = false;
      } else {
        searchData[key] = null;
      }
    }
  }
  if (storageKey) {
    removeFiltersFromStorage(storageKey);
  }
};

export const getArrayByProperty = (array, key) => {
  return array ? array.map(item => item[key]) : [];
};

export const parseArrayToString = (array) => {
  return array && array.toString();
};

export const getFile = (file) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new Error('Error parsing file'));
    };
    reader.onload = function () {
      let bytes = Array.from(new Uint8Array(this.result));
      let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(''));
      resolve({
        bytes,
        base64StringFile,
        fileName: file.name,
        fileType: file.type
      });
    };
    reader.readAsArrayBuffer(file);
  });
};

export const getFileNameFromContentDisposition = (disposition, defaultFileName) => {
  let filename = defaultFileName || '';
  if (disposition && disposition.indexOf('attachment') !== -1) {
    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    let matches = filenameRegex.exec(disposition);
    if (matches !== null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }
  return filename;
};

export const SumRows = (prop) => {
  return prop.reduce((a, b) => parseFloat((a + b).toFixed(2)), 0);
};

export const AccumSumRows = (prop) => {
  return parseFloat(_.uniq(prop)[0]).toFixed(2);
};

export const SumNegativeRows = (prop) => {
  return prop.reduce((a, b) => b < 0 ? parseFloat((a + b)) : a, 0);
};

export const SumTextRows = (prop) => {
  return _.uniq(prop).toString();
};

export const transformDateToString = (date) => {
  return date && moment(date).format(DATE_FORMAT);
}

export const transformDateFromDateRangeToStringFormatByIndex = (dateRange, index) => {
  return dateRange && dateRange[index] ? transformDateToString(dateRange[index]) : '';
};

export const sumTotalData = (iterationData, totalData) => {
  return totalData.map((item) => {
    if (item.key) {
      item.value = iterationData.reduce((prev, next) => prev + next[item.key], 0);
    } else {
      item.value = iterationData.length;
    }
    return item;
  });
};

export const sumTotalObjData = (iterationData, totalData) => {
  if (totalData.key) {
    totalData.value = iterationData.reduce((prev, next) => prev + next[totalData.key], 0);
  } else {
    totalData.value = iterationData.length;
  }
  return totalData;
};

export const getFilteredNodes = (grid) => {
  let filteredData = [];
  grid.api.forEachNodeAfterFilter(node => {
    if (node.data) { // group rows haven't data field
      filteredData.push(node);
    }
  });

  return filteredData;
}

export const getFilteredSelectedNodes = (grid) => {
  return getFilteredNodes(grid).filter(item => item.selected);
}

export const getFilteredSelectedData = (grid) => {
  return getFilteredSelectedNodes(grid).map(item => item.data);
}

export const convertTotalDataToObject = (totalData) => {
  const totalDataObject = {};
  if (totalData && totalData.length) {
    totalData.forEach(item => {
      totalDataObject[item.name] = item.value
    });
  }
  return [totalDataObject];
}

export const addColIdToColumns = (columns = []) => {
  return columns.map((column, index) => {
    column.colId = column.field || `column-${index}`;
    if (column.children) {
      column.children = column.children.map((childColumn, childIndex) => {
        if (!childColumn.colId) {
          childColumn.colId = childColumn.field || `childColumn-${index}${childIndex}`;
        }
        return childColumn;
      })
    }
    return column;
  });
};

export const isNull = (value) => {
  return typeof value === 'object' && !value;
};



// WEBPACK FOOTER //
// ./src/helpers/commonHelpers.js